export default __webpack_public_path__ + "static/media/1660.19daeb2e.png";